import { languageHelper } from "../../../config/helperFunctions";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";

function ViewInventoryAdj() {
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState();
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/inventoryadjustment/${id}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => {
        setError(err.response?.data?.message || "Error Occured");
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [id, user.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Add Inventory Adjustment")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
            <label htmlFor="" className="w-full md:w-1/3">
              <span className="text-d-bg-text text-sm mb-2 font-bold">
                {languageHelper("Reference No")}
              </span>
              <div className="mb-2 pt-0">
                <p className="mt-2 text-xs">{data.reference_no}</p>
              </div>
            </label>

            <label htmlFor="" className="w-full md:w-1/3">
              <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                {languageHelper("Date")}
              </span>
              <div className="mb-2 pt-0">
                <p className="mt-2 text-xs">{data.date}</p>
              </div>
            </label>

            <label htmlFor="" className="w-full md:w-1/3">
              <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                {languageHelper("Responsible Person")}
              </span>
              <div className="mb-2 ">
                <p className="mt-2 text-xs">{data.responsible_person.name}</p>
              </div>
            </label>
          </div>

          <table className="w-full">
            <thead className="border-b mb-2">
              <tr>
                <th className="text-left py-2 text-xs">{languageHelper("SN")}</th>
                <th className="text-left py-2 text-xs">{languageHelper("Ingredient(Code)")}</th>
                <th className="text-left py-2 text-xs">{languageHelper("Quantity/Amount")}</th>
                <th className="text-left py-2 text-xs">{languageHelper("Consumption Status")}</th>
              </tr>
            </thead>
            <tbody>
              {data.items?.map((ingredient, index) => (
                <tr key={index} className="">
                  <td className="text-left py-2 text-xs">{index + 1}</td>
                  <td className="text-left py-2 text-xs">
                    {ingredient.ingredient.name}({ingredient.ingredient.code})
                  </td>
                  <td className="text-left py-2 text-xs">
                    <p>
                      {ingredient.qty}{" "}
                      {ingredient.ingredient.ingredient_unit.unit_name}
                    </p>
                  </td>
                  <td className="text-left py-2 text-xs">
                    {ingredient.consumption_status === "plus" ? "Plus" : "Minus"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
            <label htmlFor="" className="w-full md:w-1/3">
              <span className="text-d-bg-text text-sm mb-2 font-bold">
                {languageHelper("Note")}
              </span>
              <div className="mb-2 pt-0">
                <p className="mt-2 text-xs">{data.note}</p>
              </div>
            </label>
          </div>

          <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
          <div className="flex gap-2">
            <button
              className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              onClick={() => navigate(`/admin/inventoryAdjustment/addInventoryAdjForm/${id}`)}
            >
              {languageHelper("Edit")}
            </button>
            <button
              className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              type="button"
              onClick={() => navigate(-1)}
            >
              {languageHelper("Back")}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ViewInventoryAdj;
